import { QueryClient, QueryClientProvider, QueryErrorResetBoundary } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';

import App from './App.tsx';
import Initialize from './Initialize.tsx';
import { ErrorFallback } from './components/ErrorFallback';
import { checkStageServerType } from './utils/bootstrap/checkStageServerType.ts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      gcTime: 5 * 60 * 1000,
      staleTime: 5 * 60 * 1000,
      throwOnError: true,
    },
  },
});

checkStageServerType().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryErrorResetBoundary>
        {({ reset }) => (
          <ErrorBoundary
            onReset={reset}
            FallbackComponent={ErrorFallback}
          >
            <QueryClientProvider client={queryClient}>
              <Initialize>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </Initialize>
            </QueryClientProvider>
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>
    </React.StrictMode>
  );
});
